import React, { useState } from "react"

import ContentViewer from "../components/ContentIngestion/ContentViewer"
import IngestionStatus from "../components/ContentIngestion/IngestionStatus"
import SourceManager from "../components/ContentIngestion/SourceManager"

type ActiveTab = "sources" | "content" | "status" | "playground"

const ContentIngestionScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ActiveTab>("sources")

  const tabs = [
    {
      id: "sources" as const,
      name: "Sources",
      description: "Manage content sources",
      icon: "🔗",
    },
    {
      id: "content" as const,
      name: "Content",
      description: "Browse ingested content",
      icon: "📄",
    },
    {
      id: "status" as const,
      name: "Status",
      description: "Monitor ingestion jobs",
      icon: "📊",
    },
  ]

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="bg-card border-b border-border">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-foreground">Content Ingestion</h1>
              <p className="text-muted-foreground mt-1">
                Automated content aggregation from AI news sources and X posts
              </p>
            </div>

            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <span className="inline-block w-2 h-2 bg-primary rounded-full"></span>
              <span>System Active</span>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="px-6">
          <nav className="flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === tab.id
                    ? "border-primary text-primary"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
                }`}
              >
                <span className="text-lg">{tab.icon}</span>
                <span>{tab.name}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1">
        {activeTab === "sources" && <SourceManager />}
        {activeTab === "content" && <ContentViewer />}
        {activeTab === "status" && <IngestionStatus />}
      </div>
    </div>
  )
}

export default ContentIngestionScreen
